import React from 'react';
import { Link } from 'react-router-dom';

const ProfessionalWorks = () => {
    return (
        <div>


            <div className="grid py-12 lg:grid-cols-2  lg:py-24  px-6 bg-gradient-to-r from-indigo-200 from-50% via-sky-300 via-10% to-indigo-200 to-10% rounded-xl text-black">
                <div className="">
                    <h1 className='lg:text-4xl text-2xl'>Let's go to see my professional  works</h1>
                    <div className="lg:mt-6">                   
                     <h1 class="mb-4 text-base font-normal  dark:text-black py-1">
                        If you want to explore my professional experience.I have good experience <br />with other country company.Have experience with git collaboration.
                        
                        </h1>
                    


                    </div>
                </div>

                <div className="grid justify-center items-center">
                    <Link to="/experience">
                        <button type="button" class="bg-gradient-to-r from-green-400 to-blue-500 font-bold text-white py-4 rounded-r-md  border-l border-gray-200 hover:bg-primary hover:text-white px-3">
                            <div class="flex flex-row align-middle">
                                <span class="mr-2">Let's See Works</span>
                                <svg class="w-5 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                        </button>
                    </Link>
                </div>

            </div>
        </div>
    );
};

export default ProfessionalWorks;